module.exports = __webpack_public_path__ + "static/media/promo.c17d4a15.png";